import { useInfiniteQuery } from '@tanstack/react-query'
import {
  FillPayNoticeByLocation,
  getFillPayNoticeByLocation,
} from 'api/pulse/fillPayNoticeByLocation'
import { PulsePaginatedFilters } from 'api/pulse'
import { getFillPayNoticeByLocationKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useFillPayNoticeByLocation(query: PulsePaginatedFilters) {
  return useInfiniteQuery<FillPayNoticeByLocation>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getFillPayNoticeByLocationKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getFillPayNoticeByLocation(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
  })
}
